import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { PurchasingService } from '../../../services/purchasing.service';

@Component({
	selector: 'app-vendordash-partial-receipts',
	templateUrl: './vendordash-partial-receipts.component.html',
	styleUrls: ['./vendordash-partial-receipts.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
		]),
	]
})
export class VendordashPartialReceiptsComponent implements OnInit {
	flip = 'inactive';
	@Output() viewData = new EventEmitter<any>();
	viewing: any = false;

	data: any = [];
	title = 'Partial Receipts';

	constructor(private purchasingService: PurchasingService) {}

	getRemaining(ordered: any, received: any): number {
		return parseFloat(ordered) - parseFloat(received);
	}

	ngOnInit(): void {
		this.purchasingService.getPurchaseOrders().subscribe((results: any) => {
			if (results && results.pos) {
				this.data = results.pos.filter((i: any) => {
					return parseFloat(i.ordered) > parseFloat(i.rec) && parseFloat(i.rec) > 0;
				});
			}
		});
	}

	toggleFlip(data: any, title: string) {
		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title;
			const dashboard_data = { data: data, title: this.title };
			this.viewData.emit(dashboard_data);
		} else {
			this.viewing = false;
			this.viewData.emit(false);
		}
	}
}









